import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Value = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 16px 44px 0 15px;
  background: transparent;
  border: 0;
  outline: 0;
  vertical-align: top;
  line-height: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: ${Colors.GS1000};

  &:disabled {
    color: ${Colors.GS1000};
    cursor: not-allowed;
  }

  span {
    color: ${Colors.GS600};
  }
`;
